import { ICONS, type IconName } from './icons';

interface IconProps {
  name: IconName;
  size?: number;
  className?: string;
}

/**
 * Иконка из общего набора.
 *
 * Размер намеренно не задаётся здесь по умолчанию — CSS дизайна уже описывает
 * размеры через селекторы вида `.nav-item svg` / `.btn svg`. Передавайте `size`
 * только там, где иконка стоит вне такого контекста.
 */
export function Icon({ name, size, className }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: ICONS[name] }}
    />
  );
}
